import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class SolidworksConfigurationEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "SolidworksConfiguration";
        this.primaryEnterpriseComponent = "SolidworksConfiguration";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "SolidworksConfiguration";
        eom.enterpriseComponent = "SolidworksConfiguration";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default SolidworksConfigurationEnterpriseObjectMetadata;